<template>
  <v-container fluid>
    <v-row align="center">
      <v-col>
        <v-row>
          <v-col></v-col>
        </v-row>
        <v-row>
          <v-col cols="12" align="center">
            <div class="d-inline">
              <!-- <div class="text-h4 text--secondary text-left">
                  Mapmakers API
              </div>-->
              <v-btn @click="home" text width="300">Главная</v-btn>

              <v-btn @click="api" text width="300">Сервисы</v-btn>

              <v-btn width="300" text>О нас</v-btn>
            </div>
          </v-col>
          <v-col cols="12">
            <div class="text-h3 text-center">Mapmakers API</div>
            <blockquote
              class="blockquote text-center"
            >Mapmakers API - это набор сервисов, предназначеных для работы с прогностическими и фактическими данными.</blockquote>
            <v-row class="row" v-if="isLoggedIn">
              <v-col cols="12" md="4"></v-col>
              <v-col cols="12" md="4">
                <v-card class="mx-auto" max-width="344" outlined elevation="2">
                  <v-card-text>
                    <div class="text-h5 text-center">
                      Здравствуйте,
                      {{ userName }}!
                    </div>
                    <div class="my-2 text-center">
                      <v-btn x-large color="success" dark @click="start">Начать работать!</v-btn>
                    </div>
                    <p class="text-center">Или</p>
                    <div class="my-2 text-center">
                      <v-btn x-large color="blue-grey" dark @click="logout">Выйти</v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="4"></v-col>
            </v-row>
            <div class="my-2 text-center" v-if="!isLoggedIn">
              <v-btn x-large color="success" dark @click="login">Начать использовать</v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row align="center" justify="center">
          <v-col cols="12" md="3"></v-col>
          <v-col cols="12" md="3">
            <v-card class="mx-auto" outlined elevation="2">
              <v-card-text>
                <p class="display-1 text--primary">Документация</p>
                <div
                  class="text--primary"
                >Список методов API с их описанием и примерами для пользователей</div>
                <div class="my-2">
                  <v-btn color="primary" large @click="api">Подробнее</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="3"></v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-divider></v-divider>
            <blockquote class="blockquote">© MapMakers 2022</blockquote>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "HomeView",

  data() {
    return {
      parameters: [],
      activeclass: ""
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("LOGOUT");
      this.$router.push({ name: "HOME" });
    },
    login() {
      this.$router.push({ name: "LOGIN" });
    },
    api() {
      this.$router.push({ name: "API_SERVICES" });
    },
    home() {
      this.$router.push({ name: "HOME" });
    },
    start() {
      if (this.$store.getters.IS_AUTH_USER) {
        if (this.$store.getters.IS_CONTRACT) {
          this.$router.push({ name: "USER_PRESETS" });
          return;
        }

        if (this.$store.getters.IS_RADAR_CONTRACT) {
          this.$router.push({ name: "USER_RADAR" });
          return;
        }
      } else {
        this.$router.push({ name: "DOMAINS_MAP" });
      }
    }
  },
  watch: {
    menuLink() {
      this.menuLink = null;
    }
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.IS_LOGGED_IN;
    },
    userName() {
      return this.$store.getters.USER_NAME;
    },
    isAdmin() {
      return this.$store.getters.IS_ADMIN;
    },
    isAuthUser() {
      return this.$store.getters.IS_AUTH_USER;
    }
  }
};
</script>